<template>
    <div width='100%'>
        <h2 class="section-title">{{ $t('download.titleDownload') }}</h2>
        <!-- <p>ダウンロード先</p> -->
        <el-table :data="products" :show-header="false" style="width: 100%">
            <el-table-column prop="name" width='140px'></el-table-column>
            <el-table-column width='650px'>
                <template slot-scope="props">
                    <p v-for="(item1,index1) in props.row.desc" :key="index1">
                        {{". " + item1}}
                    </p>
                    <p v-for="(item2,index2) in props.row.links" :key="index2" v-html='item2'>
                    </p>
                </template>
            </el-table-column>
        </el-table>
        <h2 class="section-title">{{ $t('download.titlePurchase') }}</h2>
        <el-table :data="Purchase" :show-header="false" style="width: 100%" :row-key="getRowKeys" :expand-row-keys="expands" @row-click="rowClick">
            <el-table-column prop="name" width='100px'></el-table-column>
            <el-table-column type='expand' width='50px'>
                  <template scope="props">
                    <p v-for="(item,index) in props.row.steps" :key="index" v-html="index+1 +'. '+item"></p>
                    </template>
                </el-table-column>
            <el-table-column prop="subtitle" width='600px'>
            </el-table-column>

        </el-table>
        <el-alert :title="$t('download.day30trial')" type="info" show-icon>
  </el-alert>
    </div>
</template>

<script>
export default {
  data: function () {
    return {
      expands: []
    }
  },
  computed: {
    products () {
      return this.$t('download.products')
    },
    Purchase () {
      return this.$t('download.purchase')
    }
  },
  methods: {
    getRowKeys (row) {
      return row.id
    },
    rowClick (row) {
      if (row.id === this.expands[0]) { // collapsed
        this.expands = []
      } else { // expand
        this.expands = []
        this.expands.push(row.id)
      }
    }
  }
}
</script>

<style scoped>
.el-table__header {
  width: 100% !important;
  /* width: 850px; */
}

.el-table__body {
  width: 100% !important;
  /* width: 850px; */
}
</style>
